<template>
	<div>
		<img :class="{ spinner: true, small: small }" :src="image" alt="Loading" />
		<div v-if="message" class="message">
			{{ message }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'Spinner',
	props: {
		small: {
			type: Boolean,
			default: false,
		},
		message: {
			type: String,
			default: '',
			required: false,
		},
	},
	computed: {
		image() {
			return require('../../assets/images/loading.svg')
		},
	},
}
</script>

<style scoped>
.spinner {
	width: 4em;
	margin: auto;
}

.spinner.small {
	width: 2.5em;
}
</style>
